import { BreadcrumbsItem } from "@atlaskit/breadcrumbs";

export default BreadcrumbsItem;
